import { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { AuthContext } from "./AuthContext";
import { API, BEARER } from "../../constant";
import { getToken, setToken, removeToken } from "../../helpers";

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState();
  const [isLoading, setIsLoading] = useState();
  const [error, setError] = useState();

  const authToken = getToken();

  const login = async ({ identifier, password }) => {
    setIsLoading(true);
    let url = `/user/login`;

    return await axios
      .post(`${API}${url}`, { email: identifier, password })
      .then((res) => {
        setError();
        setToken(res.data.token);
        setUser(res.data.user);
      })
      .catch((err) => {
        console.error(err);
        setError("Identifiant ou mot de passe incorrect");
      })
      .finally(() => setIsLoading(false));
  };

  const logout = () => {
    removeToken();
    setUser();
  };

  const getUserProfile = useCallback(async () => {
    setIsLoading(true);
    let url = `/user/me`;

    try {
      try {
        const res = await axios
          .get(`${API}${url}`, {
            headers: { Authorization: `${BEARER} ${authToken}` },
          });
        return setUser(res.data.user);
      } catch (err) {
        console.error(err);
        logout();
      }
    } finally {
      return setIsLoading(false);
    }
  }, [authToken]);

  useEffect(() => {
    if (authToken && !user) {
      getUserProfile();
    }
    if (!authToken) {
      setUser();
      setIsLoading(false);
    }
  }, [authToken, user, getUserProfile]);

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoading,
        error,
        setUser,
        setIsLoading,
        setError,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
